import { useTranslation } from 'react-i18next';

import { capitalizeFirstChar } from '../../shared/util/assessments';
import { NumberSelectQuestion } from '../questions/numberSelectQuestion/NumberSelectQuestion';
import { AssessmentPageItem } from '../types/AssessmentPageItem';

export function Energy3({
  active,
  assessmentValues,
  questionid,
  questionHeading,
  questionText,
  onOpenModal,
  onSetValue,
}: AssessmentPageItem) {
  const { t } = useTranslation();
  return (
    <div className={`question_container ${active}`} id={questionid}>
      <h1>{questionHeading}</h1>
      <p>{questionText}</p>
      <NumberSelectQuestion
        questionid="hours_worked"
        questionTitle={t('assessment.question.hours_worked')}
        minlimit={0}
        maxlimit={168}
        width=""
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
        modalText={t('EN041')}
        onOpenModal={onOpenModal}
        controlsInfo={t('EN040')}
        labelText={capitalizeFirstChar(t('EN040'))}
      />

      <NumberSelectQuestion
        questionid="days_absence"
        questionTitle={t('assessment.question.days_absence')}
        minlimit={0}
        maxlimit={100}
        width=""
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
        modalText={t('EN044')}
        onOpenModal={onOpenModal}
        skippable
        controlsInfo={t('EN043')}
        labelText={capitalizeFirstChar(t('EN043'))}
      />
    </div>
  );
}
